import React, { Fragment } from "react";

const ProcessContent = [
  {
    num: 1,
    className: "numb tran3s",
    heading: "Frame the Problem",
    desc: " It is an important part as we must regularly solve complex problems in difficult circumstances.",
    dataDelay: "",
  },
  {
    num: 2,
    className: "numb tran3s",
    heading: "Collect the Data",
    desc: "It allows you to store and analyze important information about your existing and potential customers.",
    dataDelay: "50",
  },
  {
    num: 3,
    className: "numb tran3s",
    heading: "Process the Data",
    desc: "It creates better business strategies and increase their competitive edge.",
    dataDelay: "100",
  },
];

const FancyFeatureNineteen = () => {
  return (
    <Fragment>
      <div className="block-style-thirteen" data-aos="fade-right">
        <div className="title-style-three pb-15">
          <div className="sc-title">WORK PROCESS</div>
          <h2 className="main-title">
            How we <span>process</span> & work ?
          </h2>
        </div>
        {/* /.title-style-three */}
        <ul className="style-none list-item">
          {ProcessContent.map((val, i) => (
            <li key={i} data-aos="fade-up" data-aos-delay={val.dataDelay}>
              <div className={val.className}>{val.num}</div>
              <h6>{val.heading}</h6>
              <span>{val.desc}</span>
            </li>
          ))}
        </ul>
      </div>
      {/* /.block-style-thirteen */}
    </Fragment>
  );
};

export default FancyFeatureNineteen;
